import * as React from 'react';
import styles from './BlogHeader.module.css';

interface BlogHeaderProps {
  onFilter: (value: string) => void;
}

const BlogHeader: React.SFC<BlogHeaderProps> = (props) => {
  const [searchShowing, setsSarchShowing] = React.useState(false);
  const inputRef = React.useRef<HTMLDivElement>(null);
  function onChange(e: React.ChangeEvent<HTMLInputElement>) {
    props.onFilter(e.target.value);
  }
  function showSearch() {
    setsSarchShowing(true);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.classList.add(styles.inputWrapperIn);
      }
    }, 0);
  }

  function hideSearch() {
    props.onFilter(''); // reset filter on close
    if (inputRef.current) {
      inputRef.current.classList.remove(styles.inputWrapperIn);
    }
    setTimeout(() => {
      // account for animation
      setsSarchShowing(false);
    }, 350);
  }

  const input = (
    <div className={styles.inputWrapper} ref={inputRef}>
      <input onChange={onChange} className={styles.input} autoFocus={true} placeholder="Search..." />
      <button onClick={hideSearch} className={styles.cancelButton} type="button">Cancel</button>
    </div>
  );

  return (
    <div className={styles.header}>
      {searchShowing && input}
      <h2>Blog <button onClick={showSearch} className={styles.searchButton} type="button">Search</button></h2>
    </div>
  );
};

export default BlogHeader;
